import React, { useEffect, useState } from 'react';
import Carga from '../../pages/Carga/Carga';
import axios from 'axios';
import {API_URL_LOCALE_BASE} from '../../configuration/config'
import Swal from 'sweetalert2'
import Loading from "../../Components/shared/Loading/Loading";

const Toast = Swal.mixin({
  toast: true,
  position: 'top-end',
  showConfirmButton: false,
  timer: 3000,
  timerProgressBar: true,
  didOpen: (toast) => {
    toast.addEventListener('mouseenter', Swal.stopTimer)
    toast.addEventListener('mouseleave', Swal.resumeTimer)
  }
})

const MainCP = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [selectOptions, setSelectOptions] = useState<object[]>([]);

  useEffect(() => {
    setIsLoading(true);
    axios.get(API_URL_LOCALE_BASE + 'get-tipos-grafico').then(async ({data}) => {
      // console.log(data);
      if(data.status){
        // console.log(data.response);
        setSelectOptions(data.response)
      } else {
        Swal.fire(
          'Algo salio mal :C',
          'Error al obtener data',
          'error'
        )
      }
      // console.log("Acás....")
      setIsLoading(false);
    })
    
  }, [])
  return (
    <>
      {isLoading ? <Loading loading={isLoading} /> : null}
      <Carga options={selectOptions}/>
    </>
  )
}

export default MainCP;



